import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { Upload } from "lucide-react";
import { adminListApuntados } from "@/api";

export default function Apuntados() {
  const [apuntados, setApuntados] = useState([]);

  useEffect(() => {
    adminListApuntados().then(setApuntados).catch(() => {});
  }, []);

  return (
    <div data-testid="apuntados-panel">
      <div className="flex items-center justify-between mb-4">
        <p className="text-sm text-gray-500">
          Ciudadanos que han solicitado la bonificación de la tasa de residuos, con su histórico
          de visitas al Punto Limpio registradas como sujeto pasivo del domicilio.
        </p>
        <Button variant="outline" disabled title="Próximamente: sube el padrón municipal para cruzar automáticamente" className="border-gray-300 text-gray-400 shrink-0 ml-4" data-testid="importar-censo-btn">
          <Upload className="w-4 h-4 mr-2" /> Importar censo (próximamente)
        </Button>
      </div>
      <div className="bg-white rounded-xl shadow-sm overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>DNI/NIE</TableHead>
              <TableHead>Nombre</TableHead>
              <TableHead className="hidden md:table-cell">Dirección</TableHead>
              <TableHead>Visitas</TableHead>
              <TableHead className="hidden md:table-cell">Última visita</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {apuntados.length === 0 && (
              <TableRow><TableCell colSpan={5} className="text-center text-gray-400 py-10">Sin ciudadanos apuntados todavía.</TableCell></TableRow>
            )}
            {apuntados.map((a) => (
              <TableRow key={a.dni_nie} data-testid={`apuntado-row-${a.dni_nie}`}>
                <TableCell className="font-medium text-municipal">{a.dni_nie}</TableCell>
                <TableCell>{a.nombre_apellidos}</TableCell>
                <TableCell className="hidden md:table-cell">{a.direccion}</TableCell>
                <TableCell>{a.visitas}</TableCell>
                <TableCell className="hidden md:table-cell text-xs">{a.ultima_visita ? new Date(a.ultima_visita).toLocaleDateString() : "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
